import type { Role } from '@gdladder/shared/entities';
import type { CreateRoleRequest, MoveRoleRequest, UpdateRoleRequest } from '@gdladder/shared/features';
import APIClient from '../APIClient';
import type User from '../types/User';

class RolesClient {
    async create(name: string) {
        await APIClient.post('/roles', { name } satisfies CreateRoleRequest);
    }

    async list() {
        const res = await APIClient.get<Role[]>('/roles');
        return res.data;
    }

    async listMembers(roleID: number, page: number, limit: number) {
        const res = await APIClient.get<{ total: number; users: User[] }>(`/roles/${roleID}/users`, {
            params: { page, limit },
        });
        return res.data;
    }

    async update(roleID: number, options: UpdateRoleRequest) {
        await APIClient.patch(`/roles/${roleID}`, options);
    }

    async move(roleID: number, newPosition: number) {
        await APIClient.patch(`/roles/${roleID}/position`, { newPosition } satisfies MoveRoleRequest);
    }

    async delete(roleID: number) {
        await APIClient.delete(`/roles/${roleID}`);
    }
}

export const rolesClient = new RolesClient();
